import type {
  DoorStyle,
  ProductLine,
  ClosetColor,
  HandleStyle,
  DrawerStyle,
  HardwareColor,
  StyleInfo,
} from '../types/project';

// Option lists for dropdown

// for now, we will not include milano product line
export const PRODUCT_LINES: { value: ProductLine; label: string; subtext?: string }[] = [
  {
    value: 'vista',
    label: 'Vista',
    subtext: 'Offers a clean, contemporary look that floats above the floor.',
  },
  {
    value: 'alto',
    label: 'Alto',
    subtext: 'Extending to the floor, it offers a sleek and truly custom appearance.',
  },
  {
    value: 'garage',
    label: 'Garage',
    subtext: 'Maximize storage for a garage.',
  },
  // { value: 'milano', label: 'Milano' },
];

export const CLOSET_COLORS: { value: ClosetColor; label: string }[] = [
  { value: 'white', label: 'White' },
  { value: 'grey', label: 'Grey' },
  { value: 'oak', label: 'Oak' },
  { value: 'silverGrey', label: 'Silver Grey' },
];

export const DRAWER_DOOR_COLORS: { value: ClosetColor; label: string }[] = [
  { value: 'silverGrey', label: 'Silver Grey' },
  { value: 'diamondGrey', label: 'Diamond Grey' },
];

export const HANDLE_STYLES: { value: HandleStyle; label: string }[] = [
  { value: 'knob', label: 'Knob' },
  { value: 'tBar', label: 'T-Bar' },
];

export const HARDWARE_COLORS: { value: HardwareColor; label: string }[] = [
  { value: 'black', label: 'Black' },
  { value: 'chrome', label: 'Chrome' },
  { value: 'brass', label: 'Brass' },
  { value: 'nickel', label: 'Nickel' },
];

export const DRAWER_STYLES: { value: DrawerStyle; label: string }[] = [
  { value: 'slab', label: 'Slab' },
  { value: 'shaker', label: 'Shaker' },
];

// for now, we will not include glass or mirror options
export const DOOR_STYLES: { value: DoorStyle; label: string }[] = [
  { value: 'slab', label: 'Slab' },
  { value: 'shaker', label: 'Shaker' },
  // { value: 'glass', label: 'Glass' },
  // { value: 'mirror', label: 'Mirror' },
];

export const PROJECT_SCOPES = [
  { value: 'AllClosets', label: 'All Closets' },
  { value: 'BedroomClosets', label: 'Bedroom Closets' },
  { value: 'MasterClosets', label: 'Master Closets' },
  { value: 'Custom', label: 'Custom' },
];

export const DEFAULT_STYLE_INFO_VALUES: StyleInfo = {
  color: 'white',
  handleColor: 'chrome',
  handleStyle: 'tBar',
  rodColor: 'chrome',
  drawerColor: 'white',
  drawerStyle: 'slab',
  doorColor: 'white',
  doorStyle: 'slab',
};
